import classNames from "classnames";
import { useOutputDocuments } from "providers";
import { useTranslations } from "providers";
import React from "react";

export const AgendaItemsWarning: React.FC = () => {
  const i18n = useTranslations();
  const { showAgendaItemsWarnings } = useOutputDocuments();

  if (!showAgendaItemsWarnings) return null;

  return (
    <span
      className={classNames("global-tooltip-trigger", "warning-icon")}
      title={i18n.Meeting_AgendaItems_Warning_Tooltip}
    >
      <i className="ms-Icon ms-Icon--IncidentTriangle" />
    </span>
  );
};
